import { createAction } from '@reduxjs/toolkit'

export const setRoomMenuType = createAction('SET_ROOM_TYPE')

export const setRoomMenuDestination = createAction('SET_DESTINATION')

export const setArchivedType = createAction('SET_ARCHIVED_TYPE')
